import { render } from "./borrow.vue?vue&type=template&id=5d1eb699"
import script from "./borrow.vue?vue&type=script&lang=js"
export * from "./borrow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__